"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Headset } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function IhrKiRezeptionist247ErreichbarFuerIhrUnternehmen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative w-full min-h-[600px] overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] hover:scale-[1.02]" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515015/img/modern_office_reception_blurred.png)"
    }} />
  
      {}
      <div className="absolute inset-0 bg-dark-background/60" />
  
      {}
      <div className="relative z-10 flex items-center justify-center min-h-[600px] px-6 py-16">
        <div ref={ref} className={`
            max-w-3xl w-full bg-background/90 backdrop-blur-md rounded-xl shadow-strong p-8 md:p-12
            transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)]
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
          `}>
          {}
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-primary/10 rounded-full">
              <Headset className="w-12 h-12 text-primary" strokeWidth={1.5} />
            </div>
          </div>
  
          {}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-center text-foreground mb-4 leading-tight">
            Ihr KI-Rezeptionist – 24/7 erreichbar für Ihr Unternehmen
          </h1>
  
          {}
          <p className="text-lg md:text-xl text-center text-muted-foreground mb-8">Während andere Anrufe verpassen, gewinnen sie immer mehr Kunden!<div data-ast-id="f:/src/pages/Home/sections/IhrKiRezeptionist247ErreichbarFuerIhrUnternehmen.tsx|sig:5j688g" data-ast-start="1891" data-ast-end="2008">Unser KI Asisstent Reduziert verpasste Anrufe um <strong data-start="934" data-end="942" data-ast-id="f:/src/pages/Home/sections/IhrKiRezeptionist247ErreichbarFuerIhrUnternehmen.tsx|sig:x4419x" data-ast-start="1926" data-ast-end="1979">82 %</strong> in den ersten 30 Tagen.</div></p>
  
          {}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/DemoPage" className="inline-flex items-center justify-center rounded-md bg-secondary text-foreground px-6 py-3 font-semibold transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:bg-secondary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-secondary-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary w-full sm:w-auto">
              Kostenloses Demo anfordern
            </Link>
          </div>
        </div>
      </div>
    </section>;
}